import type { ManagerRegistry } from '../../../core/manager-registry';
import type { RadialMenuItem } from '../types';
import { getIcon } from '../../../utils/icon-manager';

export const createWalkRadialButton = (registry: ManagerRegistry): RadialMenuItem => {
    return {
        id: 'walk',
        label: 'toolbar.walk',
        icon: getIcon('漫游'),
        isToggle: true,
        isActive: registry.bottomDock?.isOpen('walk') ?? false,
        onToggle: (next) => {
            const dock = registry.bottomDock;
            if (!dock) {
                console.warn('[RadialToolbar] bottom dock not initialized: walk');
                return;
            }

            if (next) {
                dock.open('walk');
            } else {
                dock.close('walk');
            }

            console.log(`[RadialToolbar] 漫游${next ? '已打开' : '已关闭'}`);
        }
    };
};
